import { render } from "./bmRaceSignInfo.vue?vue&type=template&id=206e4730&scoped=true"
import script from "./bmRaceSignInfo.vue?vue&type=script&lang=js"
export * from "./bmRaceSignInfo.vue?vue&type=script&lang=js"

import "./bmRaceSignInfo.vue?vue&type=style&index=0&id=206e4730&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206e4730"]])

export default __exports__